import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { useRecoilState } from "recoil"
import { ShowHeader } from "../../states/showHeader"
import { Box, Container, Grid, Typography } from "src/UILibrary"
import { Title } from "src/components/layout/Title"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { NewsItem } from "./components/NewsItem"
import { NewsDetailItem } from "./components/NewsDetailItem"
import { SORT_ORDER } from "src/modules/const"
import { RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import { ShowToast } from "src/states/showToast"
import { News, NewsService } from "src/openapi"
import "src/styles/common.scss"

const PAGE_SIZE = 9

export const NewsPage = () => {
  const { t } = useTranslation("translation", { keyPrefix: "news" })

  const [, setShowHeader] = useRecoilState(ShowHeader)
  const [, setShowToast] = useRecoilState(ShowToast)

  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const [pageLoad, setPageLoad] = useState<boolean>(false)
  const [end, setEnd] = useState<boolean>(false)
  const [news, setNews] = useState<News[]>([])

  const handleGetNews = (first: boolean) => {
    NewsService.newsList(
      undefined,
      news.length,
      first ? PAGE_SIZE + 5 : PAGE_SIZE,
      undefined,
      undefined,
      undefined,
      SORT_ORDER.DESCENDONG,
      "created_at"
    )
      .then((res) => {
        if (res.status === RESPONSE_CODE.SUCCESS) {
          if (
            (res.data?.news as News[]).length === 0 ||
            (first && (res.data?.news as News[]).length < PAGE_SIZE + 5) ||
            (!first && (res.data?.news as News[]).length < PAGE_SIZE) ||
            news.length + (res.data?.news as News[]).length >= res.data?.count!
          ) {
            setEnd(true)
          }
          setNews([...news, ...(res.data?.news as News[])])
        } else {
          setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
        }
      })
      .catch(() => {
        setShowToast({ show: true, text: t("failed_list"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  useEffect(() => {
    setShowHeader(true)
    if (pageLoad) {
      return
    }
    setPageLoad(true)
    handleGetNews(true)
  })

  return (
    <>
      <Title title={t("news_title")} sub_title={t("news_sub_title")} />
      <Container
        maxWidth="lg"
        className="main-body-with-footer"
        sx={{ px: isTablet ? "0px" : "10px", py: "10px", mb: "0px" }}
      >
        {news.length == 0 ? (
          <Box sx={{ display: "flex", my: "50px", width: "100%" }}>
            <Typography.SubTitleNormal
              sx={{ mx: "auto", fontFamily: "Noto Sans JP !important", color: "gray" }}
            >
              {t("no_data")}
            </Typography.SubTitleNormal>
          </Box>
        ) : (
          <>
            <Grid container minHeight={300} sx={{ mt: isTablet ? "0px" : "0px" }}>
              {news.length > 0 && (
                <Grid item md={6} sm={12} xs={12}>
                  <NewsItem item={news[0]} large />
                </Grid>
              )}
              <Grid item md={6} sm={12} xs={12}>
                <Grid container minHeight={150}>
                  {news.length >= 2 && (
                    <Grid item md={6} sm={6} xs={6}>
                      <NewsItem item={news[1]} />
                    </Grid>
                  )}
                  {news.length >= 3 && (
                    <Grid item md={6} sm={6} xs={6}>
                      <NewsItem item={news[2]} />
                    </Grid>
                  )}
                </Grid>
                <Grid container minHeight={150}>
                  {news.length >= 4 && (
                    <Grid item md={6} sm={6} xs={6}>
                      <NewsItem item={news[3]} />
                    </Grid>
                  )}
                  {news.length >= 5 && (
                    <Grid item md={6} sm={6} xs={6}>
                      <NewsItem item={news[4]} />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid container minHeight={300} className="grid_list">
              {news.map((n, index) => {
                if (index > 4) {
                  return (
                    <Grid item md={4} sm={12} xs={12} key={index}>
                      <Box sx={{ p: "10px 0px" }}>
                        <NewsDetailItem item={n} />
                      </Box>
                    </Grid>
                  )
                }
              })}
            </Grid>
            <Box className="box_show_more">
              {end ? (
                <></>
              ) : (
                <OutlinedButton caption={t("show_more")} onClick={() => handleGetNews(false)} />
              )}
            </Box>
          </>
        )}
      </Container>
    </>
  )
}
